import { Component, OnInit, ViewChild } from "@angular/core";
import { RequestsService } from "src/app/_shared/services/requests.service";
import { BaseComponent } from "src/app/_shared/utils/base-component";
import * as moment from "moment";

@Component({
  selector: "app-app-management-dashboard",
  templateUrl: "./app-management-dashboard.component.html",
  styleUrls: ["./app-management-dashboard.component.scss"],
})

export class AppManagementDashboardComponent
  extends BaseComponent
  implements OnInit
{

  dateRange = true;
  datetoday = moment();
  today =  this.datetoday.format("YYYY-MM-DD");
  yesterday = this.datetoday.subtract(1,'days').format("YYYY-MM-DD");;
  _7d = this.datetoday.subtract(7,'days').format("YYYY-MM-DD");
  _30d = this.datetoday.subtract(30,'days').format("YYYY-MM-DD");
  _12M = this.datetoday.subtract(360,'days').format("YYYY-MM-DD");

  public customDates = [
    {label:"Today", 
    gdate:this.today, 
    ldate: this.today , 
    cleanldate:this.datetoday.format('DD, MM YYY'),
    cleangdate:this.datetoday.format('DD, MM YYY')
    },

    {label:"Yesterday",gdate:this.yesterday, ldate:this.yesterday},
    {label:"7D", gdate:this.today, ldate:this._7d },
    {label:"30D", gdate:this.today,ldate:this._30d},
    {label:"3M", gdate:this.today, ldate:this._12M },
    {label:"12M", gdate:this.today, ldate:this._12M },
  ];

  //loaders
  loaderTotals = false;
  loaderUnique = false;
  loaderMostPurchased = false;


  public mostOrdered = []

  //chart 
  public farmerChartData: Array<number> = [];
  public MAChartData: Array<number> = [];
  public orderChartLabels: Array<any> = [];

  public orderDatasets: Array<any> = [
      { data: this.farmerChartData,
        label: "Smart Phone Farmers",
        fill: false,
         borderColor: 'rgb(75, 192, 192)',
         tension: 0.1
      },

      { data: this.MAChartData,
        label: "Merchants"
      }
  ];

  public orderChartOptions: any = {
    responsive: true,
    scales : {
      yAxes: [{
        ticks: {
          max : 60,
          min : 0,
        }
      }],
      xAxes: [{
  
 
        }],
    },
      plugins: {
      datalabels: {
        display: true,
        align: 'top',
        anchor: 'end',
        //color: "#2756B3",
        color: "#222",

        font: {
          family: 'FontAwesome',
          size: 14
        },
      
      },
      deferred: false

    },

  };

public startDate = "2022-01-31 01:00:00";
public endDate = "2023-01-01 00:00:00";


public loaded = false;
public uniqueFarmers = 0;
public uniqueMA = 0;
public totalAmountMA:0
public totalAmountFarmer:0

  // farmers = {};
  // vas;

  public lineGraphLabels = [];

  constructor(requestService: RequestsService) {
    super(requestService);
  }
  ngOnInit() {
    this.getGraphOrders()
  this.getMostOrdered()
  this.getUniqueCustomers()
  this.getTotalOrders()
   // this.ordersChartLabels = ["New Orders", "Serviced Orders"];
  }
  filterFarmerByMonth(farmers, months) {
    months.forEach((month) => {
      for (const key in farmers) {
        if (key === "2019") {
          farmers[key].forEach((item) => {
            if (moment(item.month).format("MMM") === month) {
             // this.farmersDateset.push(item.num_of_farmers);
            }
          });
        }
      }
    });
  }

  filterVaByMonth(vas, months) {
    months.forEach((month) => {
      // this.villageAgentsDataset.push(
      //   this.sortDataBymonth(vas["result"], month)
      // );
    });
  }

  sortDataBymonth(results = [], month) {
    const data = [];
    results.forEach((item) => {
      if (moment(item.time).format("MMM") === month) {
        data.push(item);
      }
    });
    return data.length;
  }
  
  
  setDateRange(ldate:string, gdate:string){
console.log("From:"+ldate+ " to: "+gdate)
this.startDate = ldate; 
this.endDate = gdate; 
this.getGraphOrders()
this.getMostOrdered()
this.getUniqueCustomers()
this.getTotalOrders()

  }
  getMostOrdered() {
    this.loaderMostPurchased = true;
    let params = {createdAt__lte:this.startDate, createdAt__gte:this.endDate}

    this.requestService.dashboard_fetch(`dashboard/most_purchased`, params, true).subscribe(
      (result) => {
        this.loaderMostPurchased = false;
        // console.log(result)
        this.mostOrdered = result.data
        this.loaded = true;
     
      },
      (error) => {
        this.loaderMostPurchased = false;
        this.errorMessage = "Error loading payments data";
        console.log(error)
      }
    );
  }

getUniqueCustomers() {
  this.loaderUnique = true;
    let params = {createdAt__lte:this.startDate, createdAt__gte:this.endDate}

    this.requestService.dashboard_fetch(`dashboard/unique_customers`, params, true).subscribe(
      (result) => {
        this.loaderUnique = false;
        // console.log("customers:")
        // console.log(result)
        this.uniqueMA = result.merchants //data[0].merchant
        this.uniqueFarmers = result.farmers //data[1].farmer
        this.loaded = true;
     
      },
      (error) => {
        this.loaderUnique = false;
        this.errorMessage = "";
        console.log(error)
      }
    );
  }


  getTotalOrders() {
    this.loaderTotals = true;
    let params = {createdAt__lte:this.startDate, createdAt__gte:this.endDate}

    this.requestService.dashboard_fetch(`dashboard/orders_performance`, params, true).subscribe(
      (result) => {
    this.loaderTotals = false;

        console.log("total:")
        console.log(result)
        this.totalAmountFarmer = result.farmers //data[0].farmer
        this.totalAmountMA = result.merchants //data[1].merchant
        this.loaded = true;
     
      },
      (error) => {
    this.loaderTotals = false;

        this.errorMessage = "Error loading payments data";
        console.log(error)
      }
    );
  }



  getGraphOrders() {

    let params = {createdAt__lte:this.startDate, createdAt__gte:this.endDate, period:"month"}

    this.requestService.dash_post(`dashboard/aggregate`, params, true).subscribe(
      (result) => {
        this.lineGraphLabels = this.generateLabels()
        console.log("graph:")
        console.log(result)
        let smforders = []
        for(let i ; i< this.generateLabels.length; i++) {
          let total = 0
         if(result.smf[i] !== undefined) total = result.smf[i].total
          smforders.push(total)
        }

        
     this.farmerChartData = smforders
      },
      (error) => {
        this.errorMessage = "Error loading payments data";
        console.log(error)
      }
    );
  }


   matchArraySize(originalArray: { [key: string]: any }, targetArray: { [key: string]: any }): any[] {
    const newArray: any[] = [];

    // Retrieve the keys from the target array
    const targetKeys = Object.keys(targetArray);

    // Iterate over the keys and populate the new array
    for (const key of targetKeys) {
        if (key in originalArray) {
            newArray.push(originalArray[key]);
        } else {
            // Assign a default value or leave it empty
            newArray.push(null); // You can change this line as needed
        }
    }

    return newArray;
}


generateLabels()
     { 
return ["1","2","3","4","5","6","7"]
     }
    }
    